import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrEmpty } from 'src/app/utils/string.utils';

@Pipe({
    name: 'isStringNullOrEmpty',
    standalone: false
})
export class IsStringNullOrEmptyPipe implements PipeTransform {

    transform(value?: string): boolean {
        return IsStringNullOrEmptyPipe.format(value);
    }

    static format(value?: string): boolean {
        return isNullOrEmpty(value);
    }

}
